"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  dropdownMenu: {
    background: theme.palette.background.default,
    border: '1px solid',
    borderColor: theme.palette.border.main,
    borderRadius: '0.7rem',
    boxShadow: theme.shadows[2],
    display: 'flex',
    flexDirection: 'column',
    gap: '0.1rem',
    overflow: 'auto',
    padding: '0.4rem',
    position: 'relative',
    maxHeight: '300px'
  },
  sectionHeader: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    margin: '0.5rem 0 0.2rem'
  },
  dropDownButton: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: 'transparent',
    display: 'flex',
    gap: '0.25rem',
    textAlign: 'left',
    width: '100%',
    color: theme.palette.text.primary
  },
  isSelected: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  }
}));
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = (0, _react.useState)(0);
  const groupedItems = {
    Widget: props.items.filter(item => item.type === 'WIDGET'),
    Perspective: props.items.filter(item => item.type === 'PERSPECTIVE'),
    Nodes: props.items.filter(item => item.type === 'NODE'),
    Links: props.items.filter(item => item.type === 'LINK'),
    Insights: props.items.filter(item => item.type === 'INSIGHT')
  };
  const allItems = Object.values(groupedItems).reduce((acc, curr) => acc.concat(curr), []);
  const selectItem = index => {
    const item = allItems[index];
    if (item) {
      props.command({
        id: JSON.stringify({
          id: item?.id,
          tagType: item?.type
        }),
        label: item?.title
      });
    }
  };
  const upHandler = () => {
    setSelectedIndex((selectedIndex + allItems.length - 1) % allItems.length);
  };
  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % allItems.length);
  };
  const enterHandler = () => {
    selectItem(selectedIndex);
  };
  (0, _react.useEffect)(() => setSelectedIndex(0), [props.items]);

  //@ts-ignore
  (0, _react.useImperativeHandle)(ref, () => ({
    onKeyDown: ({
      event
    }) => {
      if (event.key === 'ArrowUp') {
        upHandler();
        return true;
      }
      if (event.key === 'ArrowDown') {
        downHandler();
        return true;
      }
      if (event.key === 'Enter') {
        enterHandler();
        return true;
      }
      return false;
    }
  }));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes?.dropdownMenu,
    children: [Object.entries(groupedItems).map(([type, items]) => items.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: classes?.sectionHeader,
        children: type
      }), items.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        className: (0, _classnames.default)(classes?.dropDownButton, {
          [classes.isSelected]: selectedIndex === allItems.indexOf(item)
        }),
        onClick: () => selectItem(allItems.indexOf(item)),
        children: item.title
      }, item.id))]
    }, type)), props.items.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "item",
      children: "No result"
    })]
  });
});